// extracted by mini-css-extract-plugin
module.exports = {"root":"_3Ziq4","wrapper":"KX-J7","textArea":"_2LTAO","textAreaInner":"_3419A","title":"kh3Ju","subtitle":"_98qS6","leftButton":"_2Isd4","lowerButton":"_1lVIT","grid":"_3L1af"};